import Logo from 'components/modules/Logo/Logo';
import Navigation from '../Navigation/Navigation';

import s from './AppBar.module.css';

export default function AppBar() {
  return (
    <header className={s.header}>
      <Logo />
      <Navigation />
    </header>
  );
}
